import { useRef } from 'react'
import { Stage, Layer, Text } from 'react-konva'
import Konva from 'konva'
import { format } from 'date-fns'
import KonvaImage from '../atoms/KonvaImage'
import { FontFamily } from '../../utils/style'

type Props = {
  bgImage: string
  inputName: string
  inputMenuArr: Array<string>
  w: number
  downloadText: string
  frameImage: string
}

const Test = ({
  bgImage,
  inputName,
  inputMenuArr,
  w,
  downloadText,
  frameImage,
}: Props) => {
  const stageRef = useRef<Konva.Stage>(null)
  const temp = stageRef.current
  const originWidth = 900
  const originHeight = 1200
  const currentDate = new Date()
  const date = format(currentDate, 'yyyy/MM/dd')
  const scaleX = Math.min(w / originWidth)

  const downloadURI = (uri: string, name: string) => {
    const link = document.createElement('a')
    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleExport = () => {
    if (temp) {
      const uri = temp.toDataURL({
        mimeType: 'img/png',
        pixelRatio: 1 / scaleX,
      })
      const today = format(currentDate, 'yyyyMMdd')
      downloadURI(uri, `kinniku_report_${today}.png`)
    }
  }

  return (
    <>
      <Stage
        ref={stageRef}
        scaleX={scaleX}
        scaleY={scaleX}
        width={originWidth * scaleX}
        height={originHeight * scaleX}
        className="my-1 "
      >
        <Layer>
          <KonvaImage
            image={bgImage}
            x={0}
            y={0}
            width={originWidth}
            height={originHeight}
          />
          <Text
            text={date}
            x={170}
            y={810}
            width={300}
            fontSize={32}
            fontFamily={FontFamily.gothic}
            fontStyle={'bold'}
            fill="#ffffff"
            align="center"
          />
          <Text
            text={inputName}
            x={450}
            y={810}
            width={320}
            height={200}
            fontSize={32}
            fontFamily={FontFamily.gothic}
            fontStyle={'bold'}
            fill="#ffffff"
            align="center"
          />
          {inputMenuArr.map((item, i) => {
            return (
              <Text
                text={item}
                x={135}
                y={870 + i * 70}
                width={640}
                height={300}
                fontSize={38}
                fontFamily={FontFamily.gothic}
                fontStyle={'bold'}
                fill="#ffffff"
                align="left"
              />
            )
          })}
        </Layer>
      </Stage>
      <button
        onClick={handleExport}
        className="bg-button drop-shadow text-white font-bold text-sm rounded-lg py-3 px-5 active:scale-105 md:text-base md:px-10"
      >
        {downloadText}
      </button>
    </>
  )
}

export default Test
